import React, { useContext, useEffect, useState } from 'react'
import { Form, Tooltip, Row } from 'antd';

import { FormContext, Button, FormInput } from '@digital/ui';

import Upload, { UploadProps } from 'antd/lib/upload';

import { Visibility, VisibilityMemo } from '../Visibility';

interface ISimpleUploadProps {
    key?: string;
    onUpload: (values: any) => void;
    name?: string;
    required?: boolean;
    multiple?: boolean;
    validationSchema?: any;
    actions?: React.ReactNode[];

    fileName?: string;
    accept?: string;
    hasFile?: boolean;
    label?: string;
    hasLabel?: boolean;
    url?: string;
    disabled?: boolean;
    nameFormData?: string;
    type?: "link" | "ghost" | "default" | "primary" | "dashed" | "danger" | undefined;
    className?: string;
    idDoComponente: string;
    showUploadList?: boolean;
    span?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | undefined;
    onBeforeUpload?: () => void;
    onDownload?: () => void;
    onDownloadVisible?: boolean;
    title?: string;
    onUploadVisible?: boolean;
    visible?: boolean;

    hasJustification?: boolean;
    labelJustification?: string;
    placeholderJustification?: string;
}

export const SimpleUpload = ({
    key,
    onUpload,
    fileName,
    hasFile = false,
    accept,
    label,
    hasLabel = true,
    url,
    disabled,
    nameFormData,
    type,
    className,
    idDoComponente,
    showUploadList = true,
    onDownload,
    onDownloadVisible = true,
    title,
    onUploadVisible = true,
    visible = true,
    hasJustification = false,
    labelJustification = 'Justificativa',
    placeholderJustification = '',
    multiple = false
}: ISimpleUploadProps) => {
    const { formProps } = useContext(FormContext);

    const [arrFiles, setArrFile] = useState<any[]>();
    const [disabledItem, setDisabledItem] = useState<boolean>(false);

    const buttonLabel = label ? label : 'Adicionar arquivo';

    const nameForm = nameFormData ? nameFormData : 'arquivo'

    useEffect(() => {
        if (formProps) {
            formProps.setFieldValue(nameForm, null);
            if (hasJustification) {
                formProps.setFieldValue('justificativa', "");
            }
        }
    }, []);

    useEffect(() => {
        setDisabledItem(disabled != undefined && disabled == true ? true : false);
        fileName && setArrFile([{ uid: '1', name: fileName, url: url }]);
        let remove = !hasFile;
        if (remove) {
            setArrFile([]);
            formProps && formProps.setFieldValue(nameForm, null);
        }
    }, [fileName, hasFile]);

    const uploadProps: UploadProps = {
        action: '',
        multiple: true,
        type: 'select',
        accept: accept ? accept : '.xlsx, .xls, .png, .doc, .docx, .ppt, .pptx,.txt,.pdf',
        onChange: ({ file, fileList }) => {
            if (formProps) {
                if (multiple) {
                    const list: any[] = [];
                    fileList.forEach(file => list.push(file.originFileObj))
                    formProps.setFieldValue(nameForm, list);
                    if (file.uid === fileList[fileList.length - 1].uid) {
                        onUpload({
                            ...formProps.values,
                            [nameForm]: list
                        });
                    }
                } else {
                    formProps.setFieldValue(nameForm, file);
                    onUpload({
                        ...formProps.values,
                        [nameForm]: file
                    });
                }
            }
        },
        onRemove: _ => {
            setArrFile([]);
            formProps && formProps.setFieldValue(nameForm, null);
        },
        beforeUpload: file => {
            setArrFile([
                {
                    uid: '1',
                    name: file.name,
                },
            ]);
            formProps && formProps.setFieldValue(nameForm, file);
            return false;
        },
        headers: {
            authorization: 'authorization-text',
        },
        showUploadList
    };

    return (
        <Visibility visible={visible && (onDownloadVisible || onUploadVisible)}>
            <Form>
                <Row>
                    <VisibilityMemo
                        visible={hasJustification}
                        isFragment={false}
                    >
                        <Form.Item colon>
                            <FormInput
                                name="justificativa"
                                label={labelJustification}
                                placeholder={placeholderJustification}
                                span={12}
                                onChange={(value) => {
                                    formProps && formProps.setFieldValue('justificativa', value.target.value);
                                }}
                            />
                        </Form.Item>
                    </VisibilityMemo>
                </Row>

                <Row type='flex'>
                    <Visibility visible={onUploadVisible}>
                        <Form.Item colon>
                            <Upload
                                key={key}
                                id={idDoComponente}
                                className={className}
                                disabled={disabledItem}
                                name={nameForm}
                                {...uploadProps}
                                fileList={arrFiles}>
                                <Tooltip title={title}>
                                    <Button
                                        id='mrn-button-upload-inserirAnexo'
                                        type={type ? type : 'link'}
                                        icon="ui-upload">
                                        {hasLabel && buttonLabel}
                                    </Button>
                                </Tooltip>
                            </Upload>

                        </Form.Item>
                    </Visibility>

                    <Visibility visible={onDownloadVisible}>
                        <Tooltip title="Download Arquivo">
                            <Button
                                id='mrn-button-download-SimpleUpload'
                                type={type ? type : 'link'}
                                icon="ui-download"
                                onClick={onDownload}
                            >
                            </Button>
                        </Tooltip>
                    </Visibility>
                </Row>

            </Form>

        </Visibility>
    )
}
